export interface IVendorPayload {
    supplierId: string | null,
    supplierEntityType: string,
    name: string,
    email?: string,
    methodType: string | null,
    achAccountData: {
        routingNumber: string | null,
        accountNumber: string | null,
    },
    supplierAddressData: {
        city: string | null,
        state: string | null,
        line1: string | null,
        line2: string | null,
        postalCode: number | string | null,
        country: string | null
    } | null,
    notifyOnPayment: boolean | null
}

export interface IVendorContext {
    formActionType: string,
    filterKey: string,
    selectedVendor: IVendorPayload | undefined
}

export enum SupplierEntityTypes {
    BUSINESS = 'BUSINESS',
    INDIVIDUAL = 'INDIVIDUAL'
}
